import { FileSpreadsheet } from 'lucide-react';
import { useState } from 'react';

import { mensagemDeErro } from '@/lib/erros';
import { toast } from '@/ui/primitives/aviso';
import { Button } from '@/ui/primitives/button';
import { Input } from '@/ui/primitives/input';
import { Select } from '@/ui/primitives/select';

import { baixarPlanilhaFiscal } from './api';
import { mesDe } from './periodo';

const DIRECOES = [
  { valor: 'AMBAS', rotulo: 'Entradas e saídas' },
  { valor: 'ENTRADA', rotulo: 'Só entradas' },
  { valor: 'SAIDA', rotulo: 'Só saídas' },
];

/** Gera a planilha das 16 colunas para as empresas do escopo e o período escolhido. */
export function CartaoPlanilha({ empresaIds }: { empresaIds: readonly string[] }) {
  const [periodo, setPeriodo] = useState(() => mesDe(new Date(), 0));
  const [direcao, setDirecao] = useState('AMBAS');
  const [gerando, setGerando] = useState(false);
  const gerar = () => {
    setGerando(true);
    baixarPlanilhaFiscal({
      empresaIds: [...empresaIds],
      emitidaDe: periodo.de,
      emitidaAte: periodo.ate,
      ...(direcao === 'AMBAS' ? {} : { direcao: direcao as 'ENTRADA' | 'SAIDA' }),
    })
      .then(() => toast.success('Planilha gerada'))
      .catch((erro: unknown) => toast.error(mensagemDeErro(erro)))
      .finally(() => {
        setGerando(false);
      });
  };
  return (
    <section className="grid gap-4 rounded-painel border border-borda bg-superficie p-5">
      <header className="flex items-start gap-3">
        <FileSpreadsheet className="size-6 shrink-0 text-marca" aria-hidden />
        <div className="grid gap-1">
          <h2 className="text-lg font-semibold">Planilha fiscal (16 colunas)</h2>
          <p className="text-sm text-texto-suave">
            Abas Notas, Itens, Resumo, Pendências e Parâmetros — no formato que o fiscal envia à
            contabilidade. Usa as empresas escolhidas no topo da tela.
          </p>
        </div>
      </header>
      <div className="flex flex-wrap items-end gap-2">
        <Input
          type="date"
          aria-label="Emitidas desde"
          className="w-40"
          value={periodo.de}
          onChange={(e) => {
            setPeriodo((p) => ({ ...p, de: e.target.value }));
          }}
        />
        <Input
          type="date"
          aria-label="Emitidas até"
          className="w-40"
          value={periodo.ate}
          onChange={(e) => {
            setPeriodo((p) => ({ ...p, ate: e.target.value }));
          }}
        />
        <Button
          variante="fantasma"
          onClick={() => {
            setPeriodo(mesDe(new Date(), -1));
          }}
        >
          Mês anterior
        </Button>
        <Select
          aria-label="Direção"
          className="w-48"
          opcoes={DIRECOES}
          valor={direcao}
          aoMudar={setDirecao}
        />
      </div>
      <Button
        variante="primario"
        className="justify-self-start"
        onClick={gerar}
        carregando={gerando}
        disabled={!periodo.de || !periodo.ate}
      >
        Gerar planilha
      </Button>
    </section>
  );
}
